// extracted by mini-css-extract-plugin
module.exports = {"lightTheme":"nvrt-light_theme","darkTheme":"nvrt-dark_theme","container":"checkboxes_container__V7J9b","disabled":"checkboxes_disabled__GCUV7","box":"checkboxes_box__1iaci"};